import { render, staticRenderFns } from "./UpdateCustomerCare.vue?vue&type=template&id=ea4286c4&"
import script from "./UpdateCustomerCare.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerCare.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomerCare.vue?vue&type=style&index=0&id=ea4286c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports